var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.colorCodes),function(code){return _c('div',{key:code,staticClass:"color-box",style:({ 'background-color': _vm.colors(code) }),on:{"click":function($event){return _vm.$emit('update:selected', code)}}},[(_vm.selected === code)?_c('i',{staticClass:"fas fa-check"}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }